import type { ProgramId } from '../types/content';
export const programPaths: Record<ProgramId, string> = {
  'little-braves': '/little-braves', kids: '/kids-taekwondo', 'teens-adults': '/teens-adults', 'competition-team': '/competition-team',
};
export const programLinks = [
  { label: 'All programs', href: '/programs' },
  { label: 'Little Braves · ages 3–5', href: '/little-braves' },
  { label: 'Kids Taekwondo · ages 6–11', href: '/kids-taekwondo' },
  { label: 'Teens & Adults · ages 12+', href: '/teens-adults' },
  { label: 'Competition Team', href: '/competition-team' },
];
export const schoolLinks = [
  { label: 'Our philosophy', href: '/about-us' },
  { label: 'Our facility', href: '/the-bates-space' },
  { label: 'Testimonials', href: '/testimonials' },
  { label: 'Events & announcements', href: '/about-3' },
  { label: 'Merchandise', href: '/merch' },
  { label: 'Poomsae videos', href: '/more' },
  { label: 'Contact & free trial', href: '/free-trial-class' },
];
